import { AxiosInstance } from 'axios'

import { AllFaqParams, AllFaqResponse } from './faq'

export const FaqInternal = (axios: AxiosInstance) => ({
  all: (params: AllFaqParams) =>
    axios.get<AllFaqResponse>('/api/v1/faq', { params })
})
